import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { setShowCustomerForm } from "../../../../store/actions/newOrderSlice";
import {
  AnimatedModal,
  ModalHeader,
  ModalContent,
} from "../../../modals/AnimatedModal";
import FormCustomer, {
  CustomerFormFooter,
  CustomerFormProvider,
} from "./form/FormCustomer";

/**
 * CustomerFormModal - Modal dialog for adding/editing customer
 *
 * Opens when: showCustomerForm is true
 * Closes when: User clicks close or completes form
 */
const CustomerFormModal = () => {
  const dispatch = useDispatch();
  const showCustomerForm = useSelector(
    (state) => state.newOrder.showCustomerForm
  );

  const handleClose = () => {
    dispatch(setShowCustomerForm(false));
  };

  return (
    <AnimatedModal
      isOpen={!!showCustomerForm}
      onClose={handleClose}
      width="560px"
      maxWidth="560px"
    >
      <CustomerFormProvider>
        <ModalHeader
          title="Adicionar Cliente"
          icon={PersonAddIcon}
          onClose={handleClose}
        />
        <ModalContent padding={0}>
          <FormCustomer />
        </ModalContent>
        <CustomerFormFooter />
      </CustomerFormProvider>
    </AnimatedModal>
  );
};

export default CustomerFormModal;
